import axiosClient from './axiosClient';

export const getAssessments = () => {
  return axiosClient.get('/admin/assessments');
};

export const getAssessmentById = (id) => {
  return axiosClient.get(`/admin/assessments/${id}`);
};

export const getAssessmentQuestions = (id) => {
  return axiosClient.get(`/admin/assessments/${id}/questions`);
};

export const createAssessment = (data) => {
  // If caller provided driveId, use the nested RESTful route and do not send driveId in body
  if (data && data.driveId) {
    const { driveId, ...body } = data;
    return axiosClient.post(`/admin/drives/${driveId}/assessments`, body);
  }
  return axiosClient.post('/admin/assessments', data);
};

export const updateAssessment = (id, data) => {
  return axiosClient.put(`/admin/assessments/${id}`, data);
};

export const deleteAssessment = (id) => {
  return axiosClient.delete(`/admin/assessments/${id}`);
};

export const regenerateToken = (id) => {
  return axiosClient.post(`/admin/assessments/${id}/regenerate-token`);
};

export const addQuestionsToAssessment = (id, questionIds) => {
  return axiosClient.post(`/admin/assessments/${id}/questions`, { questionIds });
};

export const removeQuestionFromAssessment = (id, questionId) => {
  return axiosClient.delete(`/admin/assessments/${id}/questions/${questionId}`);
};
